export interface IShipment {
    referenceNumber:string,
    csr:string,
    status:string,
    salesOrder:string,
    po:string,
    bookingNumber:string,
    deliveryNumber:string,
    division:string,
    customer:string,
    shipper:string,
    incoTerms:string,
    placeOfReceipt:string,
    portOfLoading:string,
    portOfDischarge:string,
    placeOfDelivery:string,
    carrierName:string,
    vesselVoyage:string,
}

export interface IMilestoneAggregation {
    milestone: string,
    all:number,
    caution:number,
    critical:number,
    sortOrder:number
}

export enum EMilestones {
    POBooked = "POBooked",
    PendingRevision = "PendingRevision",
    OrderReleased = "OrderReleased",
    BLReceived = "BLReceived",
    SLISent = "SLISent",
    Departed = "Departed",
    Sail = "Sail",
    PendingDocuments = "PendingDocuments",
}

export enum EShipmentTrackingTypes {
    ContainerNumber = "Container Number",
    BookingNumber = "Booking Number",
    SalesOrderNumber = "Sales Order Number",
    PoNumber = "PO Number",
    DeliveryNumber = "Delivery Number",
    // DepartureDate = "Departure Date", TODO: get better requirements for this property
}

export interface ICSR {
    shipper: string,
    record: string
}

export interface IFinalDelivery {
    shipper: string,
    location: string
}